exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Io0vlmKdzd1bdsBWkW54-{display:block;margin:0 auto;position:relative;z-index:1;border:2px solid #fff}._34xJTRamDrjlTY0keE8yhc{overflow:hidden}._34xJTRamDrjlTY0keE8yhc ._3UuAa64CQq4RxOGBOMeP9M{margin:5px 10px 0 10px;overflow:hidden;text-overflow:ellipsis}\n", ""]);

// Exports
exports.locals = {
	"profileImg": "_2Io0vlmKdzd1bdsBWkW54-",
	"userCard": "_34xJTRamDrjlTY0keE8yhc",
	"displayName": "_3UuAa64CQq4RxOGBOMeP9M"
};